<template>
  <div class="post-details-container">
    <PostDetails
      :class="{ 'new-post': newPost }"
      :post="post"
      :participants="participants"
      :owner="owner"
    >
      <template #media>
        <PostMedia
          v-if="postMedia.length"
          :post="post"
          :post-media="postMedia"
          @click="
            selectedMediaIndex = $event;
            showPostDetailsModal = true;
            $emit('show-post-details-modal', true);
          "
        />
      </template>
    </PostDetails>
    <PostDetailsModal
      v-if="showPostDetailsModal"
      :post="{
        ...post,
        media: postMedia,
      }"
      :participants="participants"
      :owner="owner"
      :selected-media-index="selectedMediaIndex"
      @media-load-error="handleLoadMedia"
      @close="
        showPostDetailsModal = false;
        $emit('show-post-details-modal', false);
      "
    />
  </div>
</template>
<script lang="ts">
import type { PropType } from 'vue';
import { onMounted, ref, defineComponent } from 'vue';
import type { Participant, Post } from '@getaccept/dsr-shared-new/src/types';
import PostDetails from '@getaccept/dsr-shared-new/src/feed/components/PostDetails.vue';
import { PostMediaType } from '@getaccept/dsr-shared-new/src/types/enums/post-media-type';
import PostMedia from '@getaccept/dsr-shared-new/src/feed/components/PostMedia.vue';
import PostDetailsModal from '@getaccept/dsr-shared-new/src/feed/components/PostDetailsModal.vue';
import { MediaService } from '../../../api/media/services/media.service';

export default defineComponent({
  components: {
    PostDetails,
    PostMedia,
    PostDetailsModal,
  },
  props: {
    post: {
      type: Object as PropType<Post>,
      required: true,
    },
    participants: {
      type: Array as PropType<Participant[]>,
      default: () => [],
    },
    owner: {
      type: Object as PropType<Participant>,
      default: () => ({} as Participant),
    },
    participantId: {
      type: String,
      required: true,
    },
    newPost: {
      type: Boolean,
    },
  },
  setup(props) {
    const postMedia = ref([...props.post.media]);

    const handleLoadMedia = async () => {
      postMedia.value = await MediaService.loadMediaUrls(postMedia.value);
    };

    const showPostDetailsModal = ref(false);
    const selectedMediaIndex = ref(0);

    onMounted(() => {
      handleLoadMedia();
    });

    return {
      postMedia,
      handleLoadMedia,
      PostMediaType,
      showPostDetailsModal,
      selectedMediaIndex,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/dsr-shared-new/src/scss/post';

.new-post {
  background-color: var(--blue-95);
}
</style>
